<template>
  <div color="primary">
    <v-navigation-drawer v-model="drawer" app temporary>
      <v-list dense nav>
        <v-item @click="$router.push('/home')">
          <v-img :src="LogoCriptonomia" height="50" width="50"></v-img>
        </v-item>
        <v-list-item v-for="(item, i) in $t('links')" :key="i" link>
          <v-list-item-content>
            <v-list-item-title
              @click="$router.push(item.route)"
              style="color: #001E4A; font-size: 18px; height: 20px; font-family: Open Sans; text-transform: capitalize;"
              >{{ item.title }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <v-container>
          <v-row justify="space-around" class="d-flex align-center">
            <div class="justify-content-around" style="display: flex;">
              <v-img :src="LogoCriptonomia" height="20" width="20"></v-img>
              <p style="color: black">Criptonomia</p>
            </div>
            <div style="display: flex;">
              <v-img :src="Brasil" height="15" width="20"></v-img>
              <p style="color: black">PT-BR</p>
            </div>
          </v-row>
          <v-divider></v-divider>
        </v-container>
      </template>
    </v-navigation-drawer>

    <v-btn class="d-md-none drawer-button" rounded @click="drawer = !drawer">
      <v-icon right>mdi-menu</v-icon>
    </v-btn>

    <v-app-bar app flat height="80" color="primary">
      <v-container class="py-0 px-0 px-sm-2 fill-height">
        <router-link to="#" class="d-flex align-center text-decoration-none mr-2">
          <v-img :src="LogoCriptonomia" height="50" width="50"></v-img>
        </router-link>

        <div class="d-none d-md-block">
          <v-btn
            v-for="(item, i) in $t('links')"
            :key="i"
            text
            class="mx-1"
            color="white"
            @click="$router.push(item.route)"
            style="color: #001E4A; font-size: 18px; height: 20px; text-transform: capitalize;"
          >
            {{ item.title }}
          </v-btn>
        </div>

        <v-spacer></v-spacer>

        <div style="display: flex; justify-content: center;">
          <v-menu open-on-hover offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on">
                <v-img :src="selected[1]" height="20" width="27" style="margin-right: 5px"></v-img>
                <span style="color: white">{{ selected[0] }}</span>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(item, index) in items" :key="index">
                <v-list-item-title>
                  <v-btn
                    text
                    style="display: flex"
                    @click="changeLanguage(item.language, [item.title, item.img])"
                  >
                    <v-img :src="item.img" max-width="30" style="margin-right: 10px"></v-img>
                    {{ item.title }}
                  </v-btn>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
import LogoCriptonomia from 'Assets/Landing/logoC_red.png';
import Brasil from 'Assets/Landing/Brasil.png';
import USA from 'Assets/Landing/EUA.png';
export default {
  name: 'UserBar',
  data() {
    return {
      items: [
        { title: 'English', img: USA, language: 'en-us' },
        { title: 'Português', img: Brasil, language: 'pt-br' },
      ],
      selected: ['Português', Brasil],
      drawer: null,
      LogoCriptonomia,
      Brasil,
    };
  },
  methods: {
    changeLanguage(language, params) {
      this.$i18n.locale = language;
      this.selected = params;
    },
  },
};
</script>

<style scoped>
.drawer-button {
  position: fixed;
  top: 64px;
  left: -22px;
  z-index: 6;
}
</style>
